import React from "react";
import ComponentGallery from "../../components/gallery/ComponentGallery";
import GalleryMansory from "../../components/gallery/GalleryMansory";
import MainLayout from "../../layout/MainLayout";
import styled from "styled-components";
import Hero from "../../components/hero/Hero";

const images = [
  { url: "/img/banners/image0.jpg" },
  { url: "/img/banners/image1.jpg" },
  { url: "/img/banners/image2.jpg" },
  { url: "/img/banners/image3.jpg" },
  { url: "/img/banners/image0.jpg" },
  { url: "/img/banners/image1.jpg" },
];

const Title = styled.h2`
  font-size: 2rem;
  margin-bottom: 10px;
  font-weight: bold;
  color: #041c40;
  text-align: center;
  font: normal normal bold 60px / 53px;
`;

const Divider = styled.div`
  width: 100px;
  height: 3px;
  background-color: #f7bc0c;
  margin: 0 auto 30px;
`;

const Gallery = () => {
  return (
    <MainLayout>
      <div className="pb-4">
        <Hero title={"Portfolio / Gallery"} />
      </div>
      {/*<ComponentGallery />*/}
      <div className="pt-4 pb-4">
        <Title>Photo Gallery</Title>
        <Divider />
      </div>
      <div className="pe-4 ps-4">
        <GalleryMansory />
      </div>
      {/*<hr className="my-5"></hr>
        <h1 className="text-center text-uppercase mb-5"> Vídeo Galería</h1>*/}
    </MainLayout>
  );
};

export default Gallery;
